import React, { useEffect, useState } from "react";
import constants from "../../constants";
import _ from "lodash";
import PAGE from "../../utils/Destination";
import { useDispatch, useSelector } from "react-redux";
import * as StorageManager from "../../utils/StorageManager";
import { useQuery } from "@tanstack/react-query";
import * as axiosInstance from "../../services/axiosInstance";
import * as generalSelectors from "../../selectors/general";
import * as generalActions from "../../action/general";
function withDashboardWrapper(WrappedComponent) {
  function WithDashboardWrapper(props) {
    const generalData = useSelector((state) => generalSelectors.getGeneralData(state));
    const dispatch = useDispatch();
    const [token, setToken] = useState(null);

    useEffect(() => {
      StorageManager.retrieveToken(constants.AUTH_TOKEN).then((value) => {
        if (_.isEmpty(value)) {
          const { history } = props;
          history.push(PAGE.LOGIN);
        }
        setToken(value);
      });
    }, []);

    const { isLoading, data } = useQuery({
      queryKey: ["clientarea-config-general"],
      queryFn: async () => {
        try {
          return await axiosInstance.get(`/clientarea/config/general`);
        } catch (e) {}
      },
      retryDelay: 15000,
      enabled: !_.isEmpty(token) && _.isEmpty(generalData),
    });

    useEffect(() => {
      dispatch(generalActions.setGeneralData(data));
    }, [data]);
    return <WrappedComponent {...props} loading={isLoading} generalData={generalData} />;
  }

  return WithDashboardWrapper;
}

export default withDashboardWrapper;
